import React from "react";
import Container from "../Common/Container";
import { CarrouselProps, Item } from "./interfaces/Carrousel";
import Slider from "react-slick";
import Image from "../Common/Image";
import Text from "../Common/Text";
import {
  ArrowLeftCircleIcon,
  ArrowRightCircleIcon,
} from "@heroicons/react/24/outline";
import { DEFAULT_DATA } from "./DefaultData";

const Carrousel = ({
  data = DEFAULT_DATA,
  onChange,
  ImageProvider,
}: {
  data: CarrouselProps;
  onChange?: (value: any, id?: string) => void;
  ImageProvider?: any;
}) => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplaySpeed: parseInt(data?.time || "2", 10) * 1000,
    autoplay: true,
    slidesToShow: parseInt(data?.total || "2", 10),
    slidesToScroll: 1,
    initialSlide: 0,
    nextArrow: <ArrowRight />,
    prevArrow: <ArrowLeft />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          infinite: true,
        },
      },
    ],
  };

  if (data?.items?.length == 1) {
    return (
      <Container className="my-10">
        <Text
          editor={!!onChange}
          id="Carrousel"
          onChange={(val: any) => onChange?.(val, "title")}
        >
          {data?.title}
        </Text>
        <div className="slider-container mt-5">
          <Slide
            item={data?.items?.[0]}
            onChange={onChange}
            data={data}
            ImageProvider={ImageProvider}
          />
        </div>
      </Container>
    );
  }

  return (
    <Container className="my-10">
      <Text
        editor={!!onChange}
        id="Carrousel"
        onChange={(val: any) => onChange?.(val, "title")}
      >
        {data?.title}
      </Text>
      <div className="slider-container mt-5">
        <Slider {...settings}>
          {data?.items?.map((item) => (
            <Slide
              key={item.id}
              item={item}
              onChange={onChange}
              data={data}
              ImageProvider={ImageProvider}
            />
          ))}
        </Slider>
      </div>
    </Container>
  );
};

const Slide = ({
  item,
  onChange,
  data,
  ImageProvider,
}: {
  item: Item;
  onChange?: (value: any, id?: string) => void;
  data: CarrouselProps;
  ImageProvider: any;
}) => {
  return (
    <section className="relative isolate overflow-hidden bg-transparent px-6 ">
      {item?.image && (
        <Image
          layout={"fill"}
          height={"auto"}
          width={"100%"}
          {...item.image}
          className="w-full"
          ImageProvider={ImageProvider}
        />
      )}
      <div className="mt-5">
        <Text
          editor={!!onChange}
          id="CarrouselItem"
          onChange={(val: any) => {
            if (onChange) {
              let items = data.items;

              items = items.map((x) => {
                if (x.id === item.id) {
                  return { ...x, description: val };
                }
                return x;
              });
              onChange?.(items, "items");
            }
          }}
        >
          {item?.description}
        </Text>
      </div>
    </section>
  );
};

const ArrowRight = (props: any) => {
  const { className, style, onClick } = props;
  return (
    <ArrowRightCircleIcon
      aria-hidden="true"
      className={`${className} `}
      onClick={onClick}
      style={{
        ...style,
        display: "block",
        color: "var(--primary900)",
        width: "30px",
        height: "30px",
      }}
    />
  );
};
const ArrowLeft = (props: any) => {
  const { className, style, onClick } = props;
  return (
    <ArrowLeftCircleIcon
      aria-hidden="true"
      className={`${className} `}
      onClick={onClick}
      style={{
        ...style,
        display: "block",
        color: "var(--primary900)",
        width: "30px",
        height: "30px",
      }}
    />
  );
};

export default Carrousel;
